module.exports = __webpack_public_path__ + "img/Enjoy the Sound.e1f515e8.png";